import { RecordCard } from '../../../components/primitives/RecordCard';
import { BOARD_CHIP_LABELS } from './chipUtils';

export interface WorkItemCardChip {
  key: string;
  value: string | null;
  isEpicLink?: boolean;
  parentId?: string | null;
}

export function WorkItemCardChips({
  chips,
  cardId,
  testIdPrefix,
  onParentOpen
}: {
  chips: ReadonlyArray<WorkItemCardChip>;
  cardId: string;
  testIdPrefix: string;
  onParentOpen?: (parentId: string) => void;
}) {
  if (chips.length === 0) return null;

  return (
    <RecordCard.Meta data-testid={`${testIdPrefix}-${cardId}-chips`}>
      {chips.map((chip) => {
        const label = BOARD_CHIP_LABELS[chip.key] ?? chip.key;
        const text = `${label}: ${chip.value}`;

        if (chip.isEpicLink && chip.parentId && onParentOpen) {
          return (
            <RecordCard.Chip
              key={chip.key}
              href={`/work-item-detail/${chip.parentId}`}
              className={`pn-record-card-chip--${chip.key}`}
              data-testid={`${testIdPrefix}-${cardId}-chip-${chip.key}`}
              data-chip-key={chip.key}
              onChipClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onParentOpen(chip.parentId!);
              }}
              onPointerDown={(event) => event.stopPropagation()}
            >
              {text}
            </RecordCard.Chip>
          );
        }

        return (
          <RecordCard.Chip
            key={chip.key}
            className={`pn-record-card-chip--${chip.key}`}
            data-testid={`${testIdPrefix}-${cardId}-chip-${chip.key}`}
            data-chip-key={chip.key}
          >
            {text}
          </RecordCard.Chip>
        );
      })}
    </RecordCard.Meta>
  );
}
